// extracted by mini-css-extract-plugin
module.exports = {"news-item-box":"j","newsItemBox":"j","img-box":"k","imgBox":"k","img-mask-box":"l","imgMaskBox":"l"};